import { useFormContext } from 'react-hook-form';
// mui components
import { CircularProgress, Grid, Typography } from '@mui/material';
// components
import StyledInputContainerNewUi from 'pages/auth/components/new-ui/styled-input-container-new-ui';
import CustomTooltip from 'components/custom-tooltip';
// controllers
import SelectController from 'controllers/select-controller';
import DatePickerController from 'controllers/date-picker-controller';
// аpi
import { useGetCompanyQuery } from 'redux-store/api/company';
// icons
import AllertIcon from 'assets/icons/alert-icon.svg';
// utils
import { LAG_TYPE_OPTIONS } from 'utils/constants/lag-type.constants';
import { utcDateToZoned } from 'utils/postDateHelper';
//styles
import { setScheduleFormStyles } from '../styles/styles';

const SetScheduleFormNewUI = ({
  isFirstProject,
  formTemplateId,
  templates,
  templateSelectValues,
}) => {
  const form = useFormContext();
  const { data: companySetup } = useGetCompanyQuery(undefined);

  const startDateChangeHandler = (e) => {
    const start = utcDateToZoned(e);
    form.setValue('startDate', start);
  };

  const tooltipContent = (
    <p>
      <span>Maintain (Auto):</span> Preserves the existing time gaps (lag) between a moved task and
      its subsequent tasks, allowing grouped task adjustments without altering intervals.
      <br />
      <span>Minimum:</span>
      Automatically reschedules all subsequent tasks when a dependent task is moved, ensuring
      adherence to the shortest required time gap between tasks.
    </p>
  );

  const isWorkday = (date) => {
    const day = date.getDay();
    return companySetup?.workingDays?.every((item) => day !== item);
  };

  const isBlank = formTemplateId === -1;

  return (
    <Grid container flexDirection="column" flex={1} sx={setScheduleFormStyles.selectScheduleBody}>
      {isFirstProject && (
        <>
          <Typography sx={setScheduleFormStyles.setSchedule}>Set Schedule</Typography>

          <Typography sx={setScheduleFormStyles.selectSchedule}>
            Select Schedule template or start from scratch
          </Typography>
        </>
      )}

      <Grid container className="set-schedule" sx={setScheduleFormStyles.templatesBody}>
        {templates ? (
          <>
            <Grid container flexDirection="column" item xs={12}>
              <StyledInputContainerNewUi>
                <SelectController
                  fullWidth
                  isSelect
                  name="templateId"
                  label="Schedule Template"
                  options={templateSelectValues}
                  disabled={templateSelectValues.length === 0}
                  placeholder={
                    templateSelectValues.length === 0 ? 'Loading...' : 'Select a template'
                  }
                />
              </StyledInputContainerNewUi>
            </Grid>

            {!isBlank && (
              <Grid sx={setScheduleFormStyles.setProjectStartDate}>
                <DatePickerController
                  shouldUnregister
                  disablePast
                  icon
                  required
                  withError
                  fullWidth
                  shouldDisableDate={isWorkday}
                  name="startDate"
                  label="Project Start Date"
                  additionalOnChange={startDateChangeHandler}
                />
              </Grid>
            )}

            <Grid item sx={setScheduleFormStyles.inputContainer}>
              <SelectController
                isSelect
                withError
                name="lagType"
                label="Lag Type"
                options={LAG_TYPE_OPTIONS}
                defaultValue={companySetup.lagType}
              />

              <CustomTooltip
                title={tooltipContent}
                placement="right"
                additionalClassName="custom-tooltip"
                lightMode
              >
                <AllertIcon />
              </CustomTooltip>
            </Grid>
          </>
        ) : (
          <Grid container sx={setScheduleFormStyles.circularProgress}>
            <CircularProgress size={40} />
          </Grid>
        )}
      </Grid>
    </Grid>
  );
};

export default SetScheduleFormNewUI;
